module.exports = __webpack_public_path__ + "static/media/oaklandHigh.212e8ef3.jpg";